import PageHeader from '@Components/PageHeader';
import { ToastGuidList } from '@Components/ToastGuids';

export default function ToastGuids() {
  return (
    <div>
      <PageHeader
        navList={[
          { name: 'Settings', href: '/settings' },
          { name: 'Toast GUIDs', href: '/settings/toast-guids' },
        ]}
        title="Toast GUIDs"
      />
      <ToastGuidList />
    </div>
  );
}
